import axios from 'axios'
export default {
  name: 'Informacion',
  components: { },
  data () {
    return {
      nombre: '', celular: '', consulta: '', respuestaconsulta: '',
     errores: [], avisos: [], cargando: '', cargandoconsulta: ''
    }
  },
  mounted() {
  },
  methods: {
    atras () {
      this.$router.push('/login')
    },
    registrarconsulta: function (event) {
      if (this.verificarformreg() === true){
        this.cargandoconsulta = 'Cargando....'
        event.preventDefault();
        event.stopPropagation();
        this.enviarconsultaapi()
      }
    },
    verificarformreg: function (event) {
      this.avisos = []
      if (this.nombre === '') {
        this.avisos.push("Indique su Nombre")
      }
      if (this.celular === '') {
        this.avisos.push("Indique su Celular")
      } else {
        if (this.verificarcelular(this.celular) === false) {
          this.avisos.push("Número de Celular no válido")
        }
      }
      if (this.consulta === '') {
        this.avisos.push("Indique su consulta")
      }
     
      if(!this.avisos.length) {
        return true
      } else {
        return false
      }
    },
    verificarcelular (actual) {
    var re = /(\d{3})(\d{3})(\d{3})/g;
    var nuevo = actual.replace(re, "$1$2$3");
    var codigo = actual.replace(re, "$1");
      
      if(codigo <= 99){
      switch(codigo) {
      case '091':
          if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '092':
          if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '093':
         if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '094':
          if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '095':
         if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '096':
          if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '097':
         if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '098':
         if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      case '099':
          if(nuevo.length == "9"){
               return nuevo;
          }else{
              return false;
          }
          break;
      default:
          return false;
  }
      }else{
          return false;
      }
    },
    enviarconsultaapi () {
      let carpintero = []
      carpintero.push({'nombre': this.nombre, 'tel': this.celular, 'consulta': this.consulta })  
      axios.post(this.$apibase+'gen/consultar/', {
          "usuario": carpintero, 2006: 1
      })
      .then( response => this.pasoapi(response),  response => this.errorapi(response) )
      .catch( response => this.errorapi(response))
    },
    pasoapi: function (respuesta) {
      if (respuesta.data.estado === 1) {
          this.respuestaconsulta = 1
      } else {
        this.errorapi(respuesta)
      }
    },
    errorapi: function (respuesta) {
      if (respuesta.data.estado &&  respuesta.data.estado != 1){
        this.avisos = []
        this.avisos.push("Error en los datos enviados")
      }
      this.cargando = ''
    }
  },
  computed: {
  },
  watch: {
  }
}


// WEBPACK FOOTER //
// ./src/components/js/informacion.js